/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IDashboard {
    dashboardData(
        locationIds: number[] | null | undefined,
        createdOnOrAt: Date | null | undefined,
        includeInvoices: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<DashboardData>;
}

export const BASE_URL_TOKEN_Dashboard = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class Dashboard implements IDashboard {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
        private axios: AxiosInstance,
        private readonly baseUrl = ''
    ) {}

    dashboardData(
        locationIds: number[] | null | undefined,
        createdOnOrAt: Date | null | undefined,
        includeInvoices: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<DashboardData> {
        let url_ = '/v1/customerportal2/dashboard?';
        if (locationIds !== undefined && locationIds !== null)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (createdOnOrAt !== undefined && createdOnOrAt !== null)
            url_ +=
                'createdOnOrAt=' +
                encodeURIComponent(createdOnOrAt ? '' + createdOnOrAt.toJSON() : '') +
                '&';
        if (includeInvoices === null)
            throw new Error("The parameter 'includeInvoices' cannot be null.");
        else if (includeInvoices !== undefined)
            url_ += 'includeInvoices=' + encodeURIComponent('' + includeInvoices) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<DashboardData>(options_));
    }
}

export interface DashboardData {
    customersInvoices: DashboardCustomerInvoicesModel[];
    upcomingJobs: JobListItemWeb[];
    serviceAgreements: DashboardServiceAgreementsData[];
    latestEstimateContainers: EstimateContainerWebModel[];
    visitsDueMemberships?: DashboardMembershipSummaryModel[] | undefined;
}

export interface DashboardCustomerInvoicesModel {
    id: number;
    name: string;
    address: AddressModel;
    invoices: DashboardInvoiceModel[];
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface DashboardInvoiceModel {
    id: string;
    locationId?: number | undefined;
    totalBalanceDue: number;
}

export interface JobListItemWeb {
    id: number;
    number?: string | undefined;
    type?: string | undefined;
    status: JobListItemStatus;
    appointmentCount: number;
    firstNotCompletedAppointmentStartDate?: Date | undefined;
    firstNotCompletedAppointmentEndDate?: Date | undefined;
    lastAppointmentStartDate?: Date | undefined;
    lastAppointmentEndDate?: Date | undefined;
    serviceAgreementId?: number | undefined;
    serviceAgreementName?: string | undefined;
    arrivalWindowPlanStartDate?: Date | undefined;
    arrivalWindowPlanEndDate?: Date | undefined;
    proposal?: JobItemProposalWeb | undefined;
    serviceLocation?: LocationModel | undefined;
    invoice?: JobInvoiceDetails | undefined;
}

export enum JobListItemStatus {
    Scheduled = 0,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface JobItemProposalWeb {
    id: string;
    name: string;
    estimates: JobItemProposalEstimateWeb[];
}

export interface JobItemProposalEstimateWeb {
    id: number;
    name?: string | undefined;
    summary?: string | undefined;
    status: EstimateStatus;
    expired: boolean;
    optionName?: string | undefined;
    optionColorHex?: string | undefined;
    imageUrl?: string | undefined;
    subTotal?: number | undefined;
    totalTax?: number | undefined;
    totalPrice?: number | undefined;
    selected?: boolean | undefined;
    createdById?: number | undefined;
    businessUnitId?: number | undefined;
}

export enum EstimateStatus {
    Open = 0,
    Sold = 1,
    Dismissed = 2,
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

export interface JobInvoiceDetails {
    invoiceId?: string | undefined;
    balance: number;
    amount: number;
    dueDate?: Date | undefined;
    summary?: string | undefined;
    isAccessible: boolean;
}

export interface EstimateContainerWebModel {
    id: string;
    name: string;
    opportunityId: string;
    estimateContainerType: EstimateContainerType;
    description?: string | undefined;
    estimates: EstimateModel[];
    createdOn: Date;
    jobType?: JobTypeModel | undefined;
    jobStatus?: JobStatus | undefined;
    serviceLocation?: LocationModel | undefined;
    showEstimateTotalPrice?: boolean | undefined;
    documentLink?: string | undefined;
    tenantId: number;
    jobId?: number | undefined;
    customer?: EstimateCustomerWebModel | undefined;
}

export enum EstimateContainerType {
    EstimateBundle = 0,
    Opportunity = 1,
    ContractProposal = 2,
}

export interface EstimateModel {
    id: number;
    name: string;
    summary: string;
    status: EstimateStatus;
    expired: boolean;
    optionName?: string | undefined;
    optionColorHex?: string | undefined;
    imageUrl?: string | undefined;
    subTotal?: number | undefined;
    totalTax?: number | undefined;
    totalPrice?: number | undefined;
    selected?: boolean | undefined;
    createdById?: number | undefined;
    businessUnitId?: number | undefined;
    totalPayment: number;
    depositAmount?: number | undefined;
}

export interface JobTypeModel {
    id: number;
    name: string;
}

export enum JobStatus {
    Scheduled = 0,
    Dispatched = 1,
    InProgress = 2,
    Hold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface EstimateCustomerWebModel {
    id: number;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface DashboardMembershipSummaryModel {
    id: string;
    customerId: number;
    name: string;
    location: LocationModel;
    isAllLocations: boolean;
    isRenewed: boolean;
    visitDue: boolean;
    status: MembershipStatus;
    from?: Date | undefined;
    to?: Date | undefined;
    nextBillingDate?: Date | undefined;
}

export enum MembershipStatus {
    Active = 0,
    Suspended = 1,
    Expired = 2,
    Canceled = 3,
    Deleted = 4,
}

export interface ServiceAgreementListItem {
    id: number;
    name?: string | undefined;
    status: AgreementStatus;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    locationsCount: number;
    autoRenew: boolean;
    endingSoon: boolean;
    eSignStatus: ESignStatus;
}

export interface DashboardServiceAgreementsData extends ServiceAgreementListItem {
    coveredJobs: CoveredJob[];
    coveredLocations: AddressModel[];
}

export interface CoveredJob {
    id: number;
    status: CoveredJobStatus;
    startDate: Date;
    endDate: Date;
}

export enum CoveredJobStatus {
    Scheduled = 0,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    Canceled = 5,
    Unscheduled = 6,
}

export enum AgreementStatus {
    Draft = 0,
    Sent = 1,
    Rejected = 2,
    Accepted = 3,
    Activated = 4,
    Canceled = 5,
    Expired = 6,
    Hold = 7,
    AutoRenew = 8,
}

export enum ESignStatus {
    NotRequired = 0,
    Required = 1,
    Signed = 2,
}
